// extracted by mini-css-extract-plugin
module.exports = {"videoPlayerStub":"VideoPlayerStub_videoPlayerStub__1U_5e","defaultBound":"VideoPlayerStub_defaultBound__nxNCe"};